export function getLink() {
    const isInIframe = window.parent !== window;

    return isInIframe ? document.referrer : window.location.href;
}

export function getLinkWithPdfData(answers) {
    const url = new URL(getLink());

    url.searchParams.set('pdf_data', btoa(JSON.stringify(answers)));

    return url.toString();
}

export function getPdfData() {
    const encodedUrl = new URL(getLink());
    const pdfData = encodedUrl.searchParams.get('pdf_data');

    if (pdfData) {
        return JSON.parse(atob(pdfData));
    }

    return null;
}
